document.addEventListener('DOMContentLoaded', function () {
    const navToggle = document.querySelector('.mobile-nav-toggle');
    const navContent = document.querySelector('.mobile-nav-content');
    const navClose = document.querySelector('.mobile-nav-close');
    const overlay = document.createElement('div');
    overlay.className = 'mobile-nav-overlay';
    document.body.appendChild(overlay);
    const focusableElementsString = 'a, button, [tabindex]:not([tabindex="-1"])';
    let focusableElements;
    let submenuHistory = [];

    function toggleNav() {
        const isExpanded = navContent.getAttribute('aria-hidden') === 'true';
        navContent.style.display = isExpanded ? 'block' : 'none';
        overlay.style.display = isExpanded ? 'block' : 'none';
        navContent.setAttribute('aria-hidden', !isExpanded);
        navToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

        if (isExpanded) {
            updateFocusableElements();
            navContent.querySelector('a.mobile-menu-header, button.mobile-menu-header')?.focus();
            document.addEventListener('click', outsideClickListener);
            document.addEventListener('keydown', handleKeydown);
            overlay.addEventListener('click', overlayClickListener);
        } else {
            navToggle.focus();
            document.removeEventListener('click', outsideClickListener);
            document.removeEventListener('keydown', handleKeydown);
            overlay.removeEventListener('click', overlayClickListener);
            resetVisibility();
            closeAllSubmenus();
        }
    }

    function outsideClickListener(event) {
        if (!navContent.contains(event.target) && !navToggle.contains(event.target)) {
            closeNavAndSubmenus();
        }
    }

    function handleKeydown(event) {
        if (event.key === 'Escape') {
            closeNavAndSubmenus();
        }
    }

    function overlayClickListener() {
        closeNavAndSubmenus();
    }

    function updateFocusableElements() {
        focusableElements = Array.from(navContent.querySelectorAll(focusableElementsString));
    }

    function closeAllSubmenus() {
        document.querySelectorAll('.header__mobile-submenu.active, .header__mobile-submenu2.active').forEach(submenu => {
            submenu.classList.remove('active');
            submenu.style.display = 'none';
            submenu.previousElementSibling.setAttribute('aria-expanded', 'false');
        });
        submenuHistory = [];
    }

    function closeNavAndSubmenus() {
        if (navContent.getAttribute('aria-hidden') === 'false') {
            toggleNav();
        }
    }

    function setHiddenClassForOthers(activeElement) {
        document.querySelectorAll('.mobile-nav-header, .mobile-nav-extra-content, .mobile-nav-login, .mobile-nav-links > .list-mobile-menu__item-container').forEach(el => {
            el.classList.toggle('hidden', el !== activeElement);
            if (el.classList.contains('header__mobile-submenu') || el.classList.contains('header__mobile-submenu2')) {
                el.classList.toggle('active', el === activeElement);
            }
        });
    }

    function resetVisibility() {
        document.querySelectorAll('.mobile-nav-header, .mobile-nav-extra-content, .mobile-nav-login, .mobile-nav-links > .list-mobile-menu__item-container').forEach(el => {
            el.classList.remove('hidden');
            if (el.classList.contains('header__mobile-submenu') || el.classList.contains('header__mobile-submenu2')) {
                el.classList.remove('active');
            }
        });
        showAllMenuItems();
        showAllSubMenuItems();
    }

    function showAllMenuItems() {
        document.querySelectorAll('.mobile-menu-header').forEach(item => item.classList.remove('hidden'));
    }

    function showAllSubMenuItems() {
        document.querySelectorAll('.mobile-submenu-header').forEach(item => item.classList.remove('hidden'));
    }

    function hideOtherMenuItems(activeButton, selector) {
        document.querySelectorAll(selector).forEach(item => item.classList.toggle('hidden', item !== activeButton));
    }

    function getFocusableElements(container) {
        const focusableElements = Array.from(container.querySelectorAll(focusableElementsString));
        const hasActiveSubmenu2 = container.querySelector('.header__mobile-submenu2.active');

        return focusableElements.filter(el => {
            if (el.tagName === 'BUTTON') {
                return true;
            }

            if (el.tagName === 'A') {
                const parentDiv = el.closest('div.header__mobile-submenu2');
                if (parentDiv && !parentDiv.classList.contains('active') && !hasActiveSubmenu2) {
                    return false;
                }
                return true;
            }
            return true;
        }).concat(
            Array.from(container.querySelectorAll('button')).filter(button => {
                const nextSibling = button.nextElementSibling;
                return nextSibling && nextSibling.classList.contains('header__mobile-submenu2');
            })
        );
    }

    function handleTabNavigation(event, focusableElements) {
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                }
            } else {
                if (document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        }
    }

    function manageTabFocusWithinContainer(container) {
        const focusableElements = getFocusableElements(container);
        container.addEventListener('keydown', function (event) {
            if (event.key === 'Tab') {
                handleTabNavigation(event, focusableElements);
            }
        });
    }

    document.querySelectorAll('.header-mobile-menu button').forEach(button => {
        button.addEventListener('click', event => {
            event.stopPropagation();
            const submenu = button.nextElementSibling;
            if (submenu && (submenu.classList.contains('header__mobile-submenu') || submenu.classList.contains('header__mobile-submenu2'))) {
                if (!submenu.classList.contains('active')) {
                    submenuHistory.push(submenu);
                    submenu.classList.add('active');
                    submenu.style.display = submenu.classList.contains('header__mobile-submenu') ? 'block' : 'grid';
                    button.setAttribute('aria-expanded', 'true');
                    submenu.addEventListener('click', event => event.stopPropagation());
                    addSubmenuListeners(submenu, button);
                    manageTabFocusWithinContainer(submenu);
                    setHiddenClassForOthers(submenu);
                }
                submenu.querySelector('a, button')?.focus();
            }
            hideOtherMenuItems(button, '.mobile-menu-header');
        });
    });

    function addSubmenuListeners(submenu, parentButton) {
        const closeButton = submenu.querySelector('.mobile-submenu-close-button');
        const backButton = submenu.querySelector('.mobile-submenu-back-button');
        const subMenuButtons = submenu.querySelectorAll('.mobile-submenu-header');

        if (closeButton) {
            closeButton.addEventListener('click', event => {
                event.stopPropagation();
                closeNavAndSubmenus();
            });
            closeButton.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    closeButton.click();
                }
            });
        }

        if (backButton) {
            backButton.addEventListener('click', event => {
                event.stopPropagation();
                if (submenuHistory.length > 1) {
                    submenuHistory.pop();
                    const previousSubmenu = submenuHistory[submenuHistory.length - 1];
                    previousSubmenu.classList.add('active');
                    previousSubmenu.style.display = previousSubmenu.classList.contains('header__mobile-submenu') ? 'block' : 'grid';
                    submenu.classList.remove('active');
                    submenu.style.display = 'none';
                    setTimeout(() => {
                        parentButton.focus();
                        parentButton.setAttribute('aria-expanded', 'false');
                        setHiddenClassForOthers(previousSubmenu);
                    }, 0);
                } else {
                    submenuHistory = [];
                    submenu.classList.remove('active');
                    submenu.style.display = 'none';
                    parentButton.setAttribute('aria-expanded', 'false');
                    parentButton.focus();
                    if (!navContent.querySelector('.header__mobile-submenu.active') && !navContent.querySelector('.header__mobile-submenu2.active')) {
                        resetVisibility();
                    }
                }
                showAllSubMenuItems();
            });

            backButton.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    backButton.click();
                }
            });
        }

        subMenuButtons.forEach(subMenuButton => {
            subMenuButton.addEventListener('click', event => {
                event.stopPropagation();
                const nestedSubmenu = subMenuButton.nextElementSibling;
                if (nestedSubmenu && (nestedSubmenu.classList.contains('header__mobile-submenu') || nestedSubmenu.classList.contains('header__mobile-submenu2'))) {
                    if (!nestedSubmenu.classList.contains('active')) {
                        submenuHistory.push(nestedSubmenu);
                        nestedSubmenu.classList.add('active');
                        nestedSubmenu.style.display = nestedSubmenu.classList.contains('header__mobile-submenu') ? 'block' : 'grid';
                        subMenuButton.setAttribute('aria-expanded', 'true');
                        nestedSubmenu.addEventListener('click', event => event.stopPropagation());
                        addSubmenuListeners(nestedSubmenu, subMenuButton);
                        manageTabFocusWithinContainer(nestedSubmenu);
                        setHiddenClassForOthers(nestedSubmenu);
                    }
                    nestedSubmenu.querySelector('a, button')?.focus();
                }
                hideOtherMenuItems(subMenuButton, '.mobile-submenu-header');
            });
        });
    }

    navToggle.addEventListener('click', toggleNav);
    navClose.addEventListener('click', closeNavAndSubmenus);

    document.querySelectorAll('.mobile-nav-content a, .mobile-nav-content button').forEach(el => {
        el.addEventListener('keydown', function (event) {
            if (event.key === 'Tab') {
                const container = this.closest('.mobile-nav-content');
                if (container) {
                    handleTabNavigation(event, getFocusableElements(container));
                }
            }
        });
    });
});
